export default __webpack_public_path__ + "static/media/v_5.351bb3d9.jpg";